// extracted by mini-css-extract-plugin
export default {"headline":"TestimonialHeadline_headline__cyhRx"};